module.exports = __webpack_public_path__ + "img/3-1-2.16356ef8.png";